export default {
    strings: {
        addBulkFilesFailed: {
            0: 'Failed to add %{smart_count} file due to an internal error',
            1: 'Failed to add %{smart_count} files due to internal errors',
        },
        youCanOnlyUploadX: {
            0: 'You can only upload %{smart_count} file',
            1: 'You can only upload %{smart_count} files',
        },
        youHaveToAtLeastSelectX: {
            0: 'You have to select at least %{smart_count} file',
            1: 'You have to select at least %{smart_count} files',
        },
        aggregateExceedsSize: 'You selected %{size} of files, but maximum allowed size is %{sizeAllowed}',
        exceedsSize: '%{file} exceeds maximum allowed size of %{size}',
        missingRequiredMetaField: 'Missing required meta fields',
        missingRequiredMetaFieldOnFile: 'Missing required meta fields in %{fileName}',
        inferiorSize: 'This file is smaller than the allowed size of %{size}',
        youCanOnlyUploadFileTypes: 'You can only upload: %{types}',
        noMoreFilesAllowed: 'Cannot add more files',
        noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
        companionError: 'Connection with Companion failed',
        actionFailed: 'The action failed',
        authAborted: 'Authentication aborted',
        companionUnauthorizeHint: 'To unauthorize to your %{provider} account, please go to %{url}',
        failedToUpload: 'Failed to upload %{file}',
        noInternetConnection: 'No Internet connection',
        connectedToInternet: 'Connected to the Internet',
        // Strings for remote providers
        noFilesFound: 'You have no files or folders here',
        noSearchResults: 'Unfortunately, there are no results for this search',
        selectX: {
            0: 'Select %{smart_count}',
            1: 'Select %{smart_count}',
        },
        allFilesFromFolderNamed: 'All files from folder %{name}',
        openFolderNamed: 'Open folder %{name}',
        openFileNamed: 'Open %{name}',
        itemActionsNamed: 'Actions for %{name}',
        itemsSelected: {
            0: '%{smart_count} selected',
            1: '%{smart_count} selected',
        },
        selectMultiple: 'Select multiple',
        cancelSelection: 'Cancel selection',
        close: 'Close',
        detailSize: 'Size',
        detailType: 'Type',
        detailModified: 'Modified',
        cancel: 'Cancel',
        // Stops a long operation (moving or deleting many files) midway.
        stopOperation: 'Stop',
        dialogConfirm: 'OK',
        logOut: 'Log out',
        logIn: 'Log in',
        pickFiles: 'Pick files',
        pickPhotos: 'Pick photos',
        filter: 'Filter',
        resetFilter: 'Reset filter',
        loading: 'Loading...',
        loadedXFiles: 'Loaded %{numFiles} files',
        authenticateWithTitle: 'Please authenticate with %{pluginName} to select files',
        authenticateWith: 'Connect to %{pluginName}',
        signInWithGoogle: 'Sign in with Google',
        searchImages: 'Search for images',
        enterTextToSearch: 'Enter text to search for images',
        search: 'Search',
        resetSearch: 'Reset search',
        emptyFolderAdded: 'No files were added from empty folder',
        addedNumFiles: 'Added %{numFiles} file(s)',
        folderAlreadyAdded: 'The folder "%{folder}" was already added',
        folderAdded: {
            0: 'Added %{smart_count} file from %{folder}',
            1: 'Added %{smart_count} files from %{folder}',
        },
        additionalRestrictionsFailed: '%{count} additional restrictions were not fulfilled',
        unnamed: 'Unnamed',
        pleaseWait: 'Please wait',
        // Errors from Companion's S3 provider, which reports them as locale keys.
        s3AlreadyExists: 'A file or folder with that name already exists',
        s3Conflict: 'The file changed while it was being moved. Refresh the folder and try again',
        s3DestinationMustBeFile: 'The destination of a file must be a file path',
        s3FileTooLargeToMove: 'Files larger than 5 GB cannot be moved or renamed here',
        s3FolderMoveNotSupported: 'Folders have to be moved item by item',
        s3FolderIntoItself: 'A folder cannot be moved into itself',
        s3FolderNotEmpty: 'The folder is not empty',
        s3InvalidGrant: 'Your access to this storage could not be verified',
        s3InvalidName: 'That name is not allowed',
        s3NotConfigured: 'This storage is not available',
        s3NotFound: 'The file or folder no longer exists',
        s3OutsideAllowedFolder: 'That path is outside the folder you have access to',
        s3ReadOnlySession: 'Your session is read-only',
        s3RequestFailed: 'The storage request failed',
        s3SelectedInOtherSession: 'This file was selected in another storage session. Reconnect and select it again',
        webdavCannotConnect: 'Cannot connect to server',
    },
};
